<template>
  <section>
      <multiselect
          v-model="categoryVal"
          :options="categoriesPromptList"
          :multiple="multiple"
          :close-on-select="!multiple"
          :show-labels="false"
          :clear-on-select="false"
          :searchable="true"
          @close="closeSelect"
          @select="selectAction"
          @input="onChange"
          @search-change="searchChange"
          @open="open"
          size="sm"
      ></multiselect>
    <b-overlay :show="showOverlay > 0" class="overlay" rounded="sm"></b-overlay>
  </section>
</template>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
      name: "categorySelect",
      props: {
        initCategories: Array,
        categoriesChange: Function,
        multiple: Boolean
      },
      components: {
        Multiselect
      },
      data() {
        return {
          categoriesPromptList: [],
          categoriesList: [],
          sendTimer: null,
          categorySearch: '',
          numberPromptItem: 10,
          isOpen: false,
          showOverlay: 0,
          categoryVal: [],
          nameSeparator: '//',
        }
      },
      methods: {
        open: function () {
          this.isOpen = true
        },
        onChange: function () {
          if (!this.isOpen) {
            this.returnValue()
          }
        },
        closeSelect: function () {
          this.isOpen = false
          this.returnValue()
        },
        returnValue: function () {
          this.categoriesChange(this.getCategoryDataByName(this.categoryVal))
        },
        selectAction: function (name) {
          this.categorySearch = name
        },
        searchChange: function (searchQuery) {
          if (searchQuery.length < 2) {
            return
          }
          if (this.sendTimer != null) {
            clearTimeout(this.sendTimer);
          }
          this.sendTimer = setTimeout(() => {this.sendRequest(searchQuery)}, 1000);
        },
        sendRequest: function (searchQuery) {
          this.showOverlay ++
          this.$store.dispatch('SEND_GET', {
            url: '/category-name?name='+ searchQuery +'&limit='+
                this.numberPromptItem,
            th: this,
            getSuccessResponse: (data) => {
              this.categoriesPromptList = this.getOnlyNames(data.data)
              this.categoriesList = data.data
              this.categoriesList = this.categoriesList.concat(this.initCategories)
            },
            getResponse: () => {
              this.showOverlay --;
            },
            showSuccessMessage: false
          })
        },
        getCategoryDataByName: function (name)
        {
          if (Array.isArray(name)) {
            //todo
            if (name[0] == 'Все' ) {
              return name
            }

            let result = []
            for (let key in this.categoriesList) {
              if (name.includes(this.categoriesList[key].name) && !result.includes(this.categoriesList[key])) {
                let include = false
                for (let key2 in result) {
                  if (result[key2].id == this.categoriesList[key].id) {
                    include = true
                  }
                }
                if (!include) {
                  result.push(this.categoriesList[key])
                }
              }
            }

            return result
          } else  {
            let nameArray = name.split(this.nameSeparator)
            for (let nameKey in nameArray) {
              name = nameArray[nameKey].trim()
              for (let key in this.categoriesList) {
                if (this.categoriesList[key] === undefined) {
                  continue
                }
                let names = this.categoriesList[key].name
                for (let keyName in names) {
                  if (name === names[keyName].trim()) {
                    return this.categoriesList[key]
                  }
                }
              }
            }
          }
        },
        getOnlyNames: function (date) {
          if (date == null || date[0] == null) {
            return []
          }
          if (date[0] == 'Все') {
            return date
          }
          let nameList = []
          for (let key in date) {
            let names = []
            for (let key2 in date[key].name) {
              if (date[key].name[key2] !== "" && date[key].name[key2] !== null) {
                names.push(date[key].name[key2])
              }
            }
            nameList.push(names.join('  //  '))
          }
          return nameList
        },
      },
      computed: {
        getInitData: function () {
          return this.getOnlyNames(this.initCategories)
        }
      },
      mounted() {
      },
      created() {
        this.categoryVal = this.getInitData
        this.categoriesList = this.initCategories
      },
    }
</script>

<style scoped>
  .overlay {
    z-index: 51;
  }
</style>